<template>
  <v-card class="rounded-lg">
    <v-toolbar
        class="removeBtnPaddingRight pl-2"
        color="#DADADA"
        dense
        flat
    >
      <slot name="btn"></slot>
    </v-toolbar>
    <v-card-title>
      <v-row no-gutters class="text-left py-1">
        <v-col>
          Номер автомобиля: {{ item.number }}
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-row no-gutters class="text-left subtitle-1 py-1">
        <v-col cols="6" md="2" class="font-weight-bold">Модель:</v-col>
        <v-col cols="6" md="10" class="text-right text-md-left">{{ item.model }}</v-col>
      </v-row>
      <v-divider class="grey my-2" v-if="isGetVisitor(item)"></v-divider>
      <v-row no-gutters class="text-center subtitle-1" v-if="isGetVisitor(item)">
        <v-col cols="12" class="font-weight-bold">Список посетителей</v-col>
      </v-row>
      <v-divider class="grey my-2" v-if="isGetVisitor(item)"></v-divider>
      <v-data-table
          v-if="isGetVisitor(item)"
          :headers="headers"
          :items="item.connected_users"
          :footer-props="{'items-per-page-options':[10,15,25]}"
      >
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>

export default {
  name: "CarDetail",
  props:["item"],
  data() {
    return {
      headers: [
        {text: "ФИО", value: "fio", sortable: false, align: "start", width: "100%"}
      ]
    }
  },
  methods: {
    isGetVisitor(item){
      if (item.connected_users) {
        if (item.connected_users.length > 0) {
          return true
        }
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
.removeBtnPaddingRight>>>.v-toolbar__content{
  padding-right: 0px;
}
</style>
